module.exports = __webpack_public_path__ + "img/return-ico.45baecd8.svg";